<template>
  <div
    style="position: relative;padding-bottom: 50px;height:100%;"
  >
    <div
      ref="messageContainer"
      id="scroll-target"
      style="height: 100%;overflow-y:scroll;"
      v-on:scroll="handleScroll"
    >
      <v-fade-transition>
        <div
          v-if="unreadBanner"
          class="unreadBanner"
        >
          <div>
            <v-icon
              left
              size="19"
              style="padding-left: 15px;"
            >
              mdi-eye
            </v-icon>
            <b>This contact has unread messages.</b>
          </div>
        </div>
      </v-fade-transition>
      <div
        v-if="loading"
        style="padding: 20px;text-align:center;font-size: 18px;color: rgba(0,0,0,0.15);"
      >
        Loading...
      </div>
      <div
        v-for="message in messages"
        :key="message.id"
      >
        <div
          v-if="message.type == 'Message from Client'"
        >
          <div class="talk-bubble tri-right">
            <div
              style="padding: 8px;padding-left: 15px;"
              :style="message.read ? 'background: white;' : 'background: #ffffa8;'"
            >
              <v-icon
                v-if="message.source == 'text'"
                style="padding-right: 5px;"            
                small
              >
                mdi-cellphone-text
              </v-icon>
              <v-icon
                v-if="message.source == 'email'"  
                style="padding-right: 5px;"            
                small
              >
                email
              </v-icon>
              <b>{{message.sent_by_name}}</b>&nbsp;<span style="color: rgba(0,0,0,0.5);font-size: 12px;">{{convertToCalRef(message.sent_at)}}</span>
              <span
                v-if="checkPermission('contacts_messages_read', PERMISSIONS.CAN_EDIT)"
              >
                <v-icon
                  v-if="!message.read"
                  style="float: right;"
                  @click="read(message)"
                >
                  mdi-eye
                </v-icon>
                <v-icon
                  v-else
                  style="opacity: 0.2;float: right;"
                  @click="read(message, false)"
                >
                  mdi-eye-off-outline
                </v-icon>
              </span>
            </div>
            <div class="tri-right">
              <div class="talktext">
                <div
                  v-if="message.subject"
                  style="border-bottom: 1px solid rgba(0,0,0,0.12);"
                >
                  <span style="font-size: 14px;font-weight:bold;">{{message.subject}}</span>
                </div>
                <div
                  class="message-text"
                  :class="{ 'expanded-message-text': message.expand }"
                  style="overflow:hidden;padding-top:0px;white-space:pre-wrap;"
                  v-html="message.message"
                  @click="message.expand = !message.expand"
                />
              </div>
            </div>
          </div>
        </div>
        <div
          v-else
        >
          <div
            style="margin-right: 30px;margin-top: 10px;text-align:right;"
          >
            <span style="color: rgba(0,0,0,0.5);font-size: 12px;">{{convertToCalRef(message.sent_at)}}</span>&nbsp;<b>{{message.sent_by_name}}</b>
          </div>
          <div
            style="display: flex;margin-left: 25px;"
          >
            <div
              class="talk-bubble tri-right right-top internal"
              style="margin-left: auto;"
            >
              <div class="talktext">
                <div
                  v-if="message.subject"
                  style="border-bottom: 1px solid rgba(0,0,0,0.12);"
                >
                  <span style="font-size: 14px;font-weight:bold;">{{message.subject}}</span>
                </div>
                <div
                  class="message-text"
                  :class="{ 'expanded-message-text': message.expand }"
                  style="overflow:hidden;padding-top:0px;white-space:pre-wrap;"
                  v-html="message.message"
                  @click="message.expand = !message.expand"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <v-fade-transition>
      <div
        v-if="displayMessageEditor"
        style="background: rgba(0,0,0,0.2);position: absolute; top:0;left:0;right:0;bottom:0;"
        @click="displayMessageEditor = false"
      />
    </v-fade-transition>

    <div
      v-if="checkPermission('contacts_messages', PERMISSIONS.CAN_CREATE)"
      style="position: absolute; bottom:0;left:0;right:0;background: white;border-top: 1px solid rgba(0,0,0,0.12);z-index: 99;"
    >
      <v-expand-transition>
        <div
          v-if="displayMessageEditor"
          style="padding: 15px;border-bottom: 1px solid rgba(0,0,0,0.05);"
        >
          <span style="color: grey;"><b>To: </b>{{contact.email}} ({{contact.full_name}})</span><br />
          <span style="color: grey;"><b>From: </b><span class="legalFoot"></span></span>
        </div>
      </v-expand-transition>
      <v-text-field
        v-if="!displayMessageEditor"
        v-model="direct_message.subject"
        hide-details
        :label="disabledMessages ? 'Enable Contact or add an email to send messages' : 'Send a message to ' + contact.first_name"
        :disabled="disabledMessages"
        :solo="!displayMessageEditor"
        @focus="displayMessageEditor = true"
      />
      <v-expand-transition>
        <div
          v-if="displayMessageEditor"
          style="position:relative;"
        >
          <div
            style="padding: 15px;padding-top: 0;"
          >
            <v-text-field
              v-model="direct_message.subject"
              hide-details
              label="Subject (optional)"
            />
            <br />
            Message:
            <Editor
              enable_formatting="true"
              ref="htmlEditor"
              style="background: white;color: black;"
            />
            <div
              v-if="domainInfo.text_enabled"
            >
              <b>Messages over 300 characters will be truncated for text notifications</b>
            </div>
          </div>
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="grey"
              flat
              @click="displayMessageEditor = false"
            >
              Cancel
            </v-btn>
            <v-btn
              :disabled="sending"
              color="blue"
              dark
              @click="sendMessage()"
            >
              Send
            </v-btn>
          </v-card-actions>
        </div>
      </v-expand-transition>
    </div>
    <v-dialog
      v-model="limit_text"
      persistent
      width="400"
    >
      <v-card>
        <v-card-text>
          <b>Warning</b>: Your message is over 300 characters. The text notification will be truncated.
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            @click="limit_text = false"
          >
            Go Back
          </v-btn>
          <v-btn
            color="primary"
            dark
            @click="sendMessage();limit_text = false;sending = true"
          >
            Send
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import api from '@/api'
import Editor from '@/components/admin/Editor'
import { mapGetters } from 'vuex'

export default {
  name: 'ContactMessages',
  props: [ 'contact' ],
  components: {
    Editor
  },
  data () {
    return {
      messages: [],
      page: 1,
      count: 0,
      max_pages: 0,
      unread: 0,
      loading: false,
      displayMessageEditor: false,
      direct_message: {},
      scroll_down: true,
      limit_text: false,
      sending: false
    }
  },
  computed: {
    ...mapGetters('auth', [
      'getDomainInfo',
    ]),
    noMoreMessages () {
      if (this.count < 5) {
        return true
      }
      if (this.page === this.max_pages) {
        return true
      }
      return false
    },
    disabledMessages () {
      return !this.contact.is_active || !this.contact.email
    },
    unreadBanner () {
      var checkMessages = false
      this.messages.forEach((message) => {
        if (!message.read && message.type == "Message from Client")
          checkMessages = true
      })
      return checkMessages
    }
  },
  created () {
    this.loadNotifications()
    this.domainInfo = this.getDomainInfo
  },
  methods: {
    handleScroll (e) {
      if (e.target.scrollTop < 250 && !this.loading && !this.noMoreMessages) {
        this.page++
        this.loadNotifications()
      }
    },
    loadNotifications () {
      this.loading = true
      api.userform.contactNotifications.get(this.contact, { pageNum: this.page, count: 10 })
        .then(data => {
          data.results.forEach((message) => {
            message.expand = false
            this.messages.unshift(message)
          })
          this.loading = false
          this.count = data.count
          this.page = data.page_number
          this.max_pages = data.num_pages
        })
        .finally(() => {
          if (this.scroll_down) {
            this.$refs.messageContainer.scrollTop = Math.floor (this.$refs.messageContainer.scrollHeight)
            this.scroll_down = false
          }
        })
    },
    sendMessage() {
      this.loading = true
      var temp = this.$refs.htmlEditor.getHTML()
      if (temp.replace( /(<([^>]+)>)/ig, '').length > 300 && !this.limit_text && this.domainInfo.text_enabled) {
        this.limit_text = true
        this.sending = false
      } else {
        api.userform.contact.sendMessage(this.contact, {
          'subject': this.direct_message.subject,
          'body': this.$refs.htmlEditor.getHTML(),
        })
        .then(() => {
          this.messages = []
          this.page = 1
          this.loading = false
          this.scroll_down = true
          this.direct_message = {}
          this.sending=false
          this.displayMessageEditor = false
          this.loadNotifications()
        })
      }
    },
    read (item, read = true) {
      api.userform.contactNotifications.read(this.contact, item, read)
      .then(() => {
        item.read = read
      })
    }
  }
}
</script>

<style>
/* CSS talk bubble */
.talk-bubble {
	margin: 0px 25px 10px 25px;
  display: inline-block;
  position: relative;
	height: auto;
  background: rgb(242, 242, 242);
}

.internal {
  background: rgb(222, 238, 255);
}

.tri-right.left-top:after{
	content: ' ';
	position: absolute;
	width: 0;
	height: 0;
  left: -20px;
	right: auto;
  top: 0px;
	bottom: auto;
	border: 22px solid;
	border-color: rgb(242, 242, 242) transparent transparent transparent;
}

.tri-right.right-top:after{
	content: ' ';
	position: absolute;
	width: 0;
	height: 0;
  left: auto;
	right: -20px;
  top: 0px;
	bottom: auto;
	border: 20px solid;
  border-color:rgb(222, 238, 255) transparent transparent transparent;
}

/* talk bubble contents */
.talktext{
  padding: 1em;
	text-align: left;
  line-height: 1.5em;
}
.talktext p{
  /* remove webkit p margins */
  -webkit-margin-before: 0em;
  -webkit-margin-after: 0em;
}


/* MESSAGES ^ */

.message-text {
  position : relative;
  max-height: 300px;
}

.message-text:before {
  content:'';
  width:100%;
  height:100%;
  position:absolute;
  left:0;
  top:0;
  background:linear-gradient(transparent 175px, white);
}

.message-text:after {
  content:'Click to Expand';
  color:blue;
  text-decoration: underline;
  height:100%;
  position:absolute;
  top:270px;
  right:20px;
  font-weight:700;
}

@-webkit-keyframes expandTransition {
  from {max-height: 300px;}
  to {max-height: 100%;}
}

@keyframes expandTransition {
  from {max-height: 300px;}
  to {max-height: 100%;}
}

.expanded-message-text {
  animation: expandTransition 4s forwards;
  -webkit-animation: expandTransition 4s forwards;
}

.expanded-message-text:before {
  background: 0 !important;
}

.expanded-message-text:after {
  content:'' !important;
}

.unreadBanner {
  position: absolute;
  border-bottom: 1px solid rgba(0,0,0,0.2);
  top:0;
  left:0;
  right:0;
  background: #ffff72;
  color: black;
  width: 100%;
  z-index: 1;
  padding: 10px;
}

.unreadBanner:hover {
  top: -42px;
}
</style>
